/* eslint-disable */
import type { AxiosResponse } from "axios";
import SpaToolsApiClient from "./base/SpaToolsApiClient";

export type Property = {
    id: number;
    name: string;
    titleInDropdown: string | null;
};

export type GetPropertyListResponse = {
    properties: Property[];
};

export type PropertyUpdateResponse = {
    unitBuilderUpdates: string,
    residentBuilderUpdates: string
}

// Payload returned by the backend on HTTP 400 (validation error).
export type PropertyUpdateValidationError = {
    error: string
}

// Payload returned by the backend on HTTP 500 (unexpected error/exception).
export type PropertyUpdateServerError = {
    message: string,
    traceId?: string
}

export default class ApplicationApi extends SpaToolsApiClient {

    async getPropertyListAsync(): Promise<AxiosResponse<GetPropertyListResponse>> {
        return this.get(`/GetPropertyList`);
    }
    
    async updatePropertyAsync(propertyId: string | number): Promise<AxiosResponse<PropertyUpdateResponse>> {
        if (!propertyId) { throw new Error("propertyId é obrigatório."); }
        const encodedCompanyKey = encodeURIComponent(String(propertyId));
        return this.get(`/BuilderLinkUpdate?companykey=${encodedCompanyKey}`);
    }
}